import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Home from '../../Home/components/Home';
import Tour from '../../App/components/Tour';
import { createStructuredSelector } from 'reselect';
import { property } from 'lodash';
import { bindActionCreators } from 'redux';
import { STEP_GROUPS } from '../components/Tour/steps/index';
import REACT_CONFIG from 'REACT_CONFIG';
import config from 'config';
import { remotePaths } from 'router/routes';

const mapStateToProps = createStructuredSelector({
  user: property('app.user'),
  showTour: property('app.showTour'),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      goToTaxesPage: () => config.goToNewLK(remotePaths.taxes),
    },
    dispatch,
  );

class HomeContainer extends Component {
  static propTypes = {
    user: PropTypes.object,
    showTour: PropTypes.bool.isRequired,
    tourFinishedAction: PropTypes.func,
    goToTaxesPage: PropTypes.func.isRequired,
  };

  render() {
    const { user, showTour, goToTaxesPage } = this.props;
    return (
      <>
        <Tour
          group={STEP_GROUPS.MAIN}
          showTour={showTour && !REACT_CONFIG.REACT_APP_HIDE_TOUR}
          tourFinishedAction={goToTaxesPage}
        />
        <Home
          toPay={user.getIn(['data', 'toPay'])}
          accrualIsPresent={user.getIn(['data', 'accrualIsPresent'])}
          hasDebts={user.getIn(['data', 'hasDebts'])}
        />
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);
